import { createFileRoute } from '@tanstack/react-router';
import { ControlCenter } from '@/features/control-center';

export const Route = createFileRoute('/_authenticated/my-campaigns/')({
    component: ControlCenter,
    head: () => ({
        meta: [{ title: 'My Campaigns | promote.fun' }],
    }),
});
